<div class="bmc-interfaces-container">
    <h5>{{'INTERFACES.TITLE' | translate}}</h5>
    <div class="bmc-interfaces-container__header-container">
        <div class="bmc-interfaces-container__external-system-section">
            <label
                class="bmc-interfaces-select__external-system-title">{{'INTERFACES.EXTERNAL_SYSTEM' | translate}}</label>
            <bzg-select [placeholder]="'INTERFACES.SELECT_EXTERNAL_SYSTEM' | translate"
                (valueChange)="selectExternalSystem($event)">
                <bzg-option *ngFor="let externalSystem of externalSystems" [value]="externalSystem">
                    {{externalSystem.displayName}}
                </bzg-option>
            </bzg-select>
        </div>
    </div>
    <div class="bmc-interfaces">
        <div class="bmc-interfaces-select">
            <div class="bmc-interfaces-select__list-section" *ngIf="selectedExternalSystem">
                <label class="bmc-interfaces-select__title">{{'INTERFACES.TITLE_SELECT' | translate}}</label>
                <ul class="bmc-interfaces-select__list">
                    <li *ngFor="let interface of selectedExternalSystem.nodes" (click)="selectInterface(interface)"
                        class="bz-space--inline-s"
                        [ngClass]="{'bz-color-bg--theme-100': selectedInterface && selectedInterface.interface.id === interface.id}">
                        <bzg-icon [nameIcon]="interface.type === 'Rest' ? 'icon-rest' : 'icon-soap'" [size]="14">
                        </bzg-icon>
                        <span>{{interface.displayName}}</span>
                    </li>
                </ul>
            </div>
        </div>

        <div class="bmc-interfaces-config" *ngIf="selectedExternalSystem">

            <div class="bz-env-loading">
                <bounce *ngIf="isBusy"></bounce>
            </div>

            <div class="bmc-interfaces-config__container" *ngIf="selectedInterface && !isBusy">
                <div class="bmc-interfaces-config__header"
                    [ngClass]="{'bmc-interfaces-config__header--rest': selectedInterface.interface.interfacetype === 'Rest'}">
                    <div
                        [ngClass]="{'bmc-interfaces-config__header-title--rest': selectedInterface.interface.interfacetype === 'Rest'}">
                        <label class="bmc-interfaces-config__title">{{selectedInterface.interface.displayname}}</label>
                        <div class="bmc-interfaces-config__container-content-type"
                            *ngIf="selectedInterface.interface.interfacetype === 'Rest'">
                            <label
                                class="bmc-interfaces-config__content-type">{{'INTERFACES.CONTENT_TYPE' | translate}}</label>
                            <bzg-select placeHolder="{{ 'INTERFACES.SELECT_CONTENT_TYPE' | translate }}"
                                [(value)]="selectedInterface.interface.contenttype" (select)="selectedInterface.interface.contenttype = $event">
                                <bzg-option *ngFor="let contentType of contentTypes"
                                    [value]="contentType">
                                    {{contentType}}
                                </bzg-option>
                            </bzg-select>
                        </div>
                    </div>
                    <div class="bmc-interfaces-config__interface-type"
                        [ngClass]="{'bmc-interfaces-config__interface-type--soap': selectedInterface.interface.interfacetype === 'Soap', 
                        'bmc-interfaces-config__interface-type--rest': selectedInterface.interface.interfacetype === 'Rest'}">
                        <div class="bmc-interfaces-config__interface-type-title"
                            [ngClass]="{'bmc-interfaces-config__interface-type-title--soap': selectedInterface.interface.interfacetype === 'Soap', 'bmc-interfaces-config__interface-type-title--rest': selectedInterface.interface.interfacetype === 'Rest'}">
                            <bzg-icon
                                [nameIcon]="selectedInterface.interface.interfacetype === 'Soap' ? 'icon-soap' : 'icon-rest'"
                                [size]="24"></bzg-icon>
                            <label
                                class="bmc-interfaces-config__interface-type-text">{{(selectedInterface.interface.interfacetype === 'Soap' ? 'INTERFACES.TYPE_SOAP' : 'INTERFACES.TYPE_REST') | translate}}</label>
                        </div>
                        
                    </div>
                </div>
                <div class="bmc-interfaces-config__tabs-section">
                    <bzg-tab-set (onSelectTab)="selectedTab = $event.index">
                        <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 0}" displayName="{{'INTERFACES.PROPERTIES' | translate | uppercase}}">
                            <connect-interfaces-properties #propertiesForm 
                                class="bmc-interfaces-config__tabs-section__properties"
                                [ngClass]="{'bmc-interfaces-config__tabs-section__properties--rest': selectedInterface.interface.interfacetype === 'Rest'}"
                                [selectedInterface]="selectedInterface" 
                                [metadata]="interfacesMetadata[selectedInterface.interface.interfacetype].properties">
                            </connect-interfaces-properties>
                        </bzg-tab-item>
                        <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 1}" displayName="{{'INTERFACES.ADV_OPTIONS' | translate | uppercase}}">
                            <connect-interfaces-adv 
                                class="bmc-interfaces-config__tabs-section__adv"
                                [ngClass]="{'bmc-interfaces-config__tabs-section__adv--rest': selectedInterface.interface.interfacetype === 'Rest'}"
                                #advancedForm 
                                [selectedInterface]="selectedInterface" 
                                [metadata]="interfacesMetadata.advancedWebService">
                            </connect-interfaces-adv>
                        </bzg-tab-item>
                    </bzg-tab-set>
                </div>
                <div *ngIf="selectedInterface" class="bmc-interfaces-config__buttons">
                    <bzg-button-secondary (click)="cancelChanges()">
                        {{ 'GLOBAL.CANCEL' | translate }}
                    </bzg-button-secondary>

                    <bzg-button-primary class="bmc-interfaces-config__btn-primary" (click)="applyChanges()">
                        {{ 'GLOBAL.APPLY' | translate }}
                    </bzg-button-primary>
                </div>
            </div>
        </div>

    </div>
</div>